"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _List = require("./List");
require("./Group.scss");
var Group = function Group(_ref) {
  var className = _ref.className,
    group = _ref.group,
    onLinkClick = _ref.onLinkClick;
  var List = Group.List;
  var header = group.header,
    links = group.links;
  var rootClassName = (0, _classnames["default"])('cds-Navigation-Group', {
    'cds-Navigation-Group--Center': !header
  }, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, header && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "cds-Navigation-Header"
  }, header), Array.isArray(links) && links.length > 0 && /*#__PURE__*/_react["default"].createElement(List, {
    links: links,
    onLinkClick: onLinkClick
  }));
};
exports.Group = Group;
Group.List = _List.List;